export default __webpack_public_path__ + "static/media/experts.db46a763.svg";